/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SubjectContactBaseResponseDto } from './subjectContactBaseResponseDto.model';
import { ContractRole } from './contractRole.model';


export interface ConcernedSubjectContactDto { 
    concernedId?: number;
    contractRole?: ContractRole;
    ico?: string;
    lpisUserId?: number;
    opsubId?: number;
    rodneCislo?: string;
    subjectContact?: SubjectContactBaseResponseDto;
}
export namespace ConcernedSubjectContactDto {
}


